"use strict";

exports.__esModule = true;
exports.GraphQLJSONObject = exports["default"] = exports.GraphQLJSON = void 0;

var _graphql = require("graphql");

var _language = require("graphql/language");

function identity(value) {
  return value;
}

function ensureObject(value) {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    throw new TypeError("JSONObject cannot represent non-object value: " + value);
  }

  return value;
}

function parseObject(ast, variables) {
  var value = Object.create(null);
  ast.fields.forEach(function (field) {
    // eslint-disable-next-line no-use-before-define
    value[field.name.value] = parseLiteral(field.value, variables);
  });
  return value;
}

function parseLiteral(ast, variables) {
  switch (ast.kind) {
    case _language.Kind.STRING:
    case _language.Kind.BOOLEAN:
      return ast.value;

    case _language.Kind.INT:
    case _language.Kind.FLOAT:
      return parseFloat(ast.value);

    case _language.Kind.OBJECT:
      return parseObject(ast, variables);

    case _language.Kind.LIST:
      return ast.values.map(function (n) {
        return parseLiteral(n, variables);
      });

    case _language.Kind.NULL:
      return null;

    case _language.Kind.VARIABLE:
      {
        var name = ast.name.value;
        return variables ? variables[name] : undefined;
      }

    default:
      return undefined;
  }
} // This named export is intended for users of CommonJS. Users of ES modules
// should instead use the default export.


var GraphQLJSON = new _graphql.GraphQLScalarType({
  name: 'JSON',
  description: 'The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).',
  serialize: identity,
  parseValue: identity,
  parseLiteral: parseLiteral
});
exports.GraphQLJSON = GraphQLJSON;
var _default = GraphQLJSON;
exports["default"] = _default;
var GraphQLJSONObject = new _graphql.GraphQLScalarType({
  name: 'JSONObject',
  description: 'The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).',
  serialize: ensureObject,
  parseValue: ensureObject,
  parseLiteral: parseObject
});
exports.GraphQLJSONObject = GraphQLJSONObject;